module.exports = __webpack_public_path__ + "static/media/wx-tips.4ee446bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/UpApp/images/wx-tips.png
// module id = 425
// module chunks = 5